<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-6">
                <div class="search-box mr-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <input
                      type="text"
                      class="form-control"
                      v-model="search"
                      placeholder="Digite e pressione 'ENTER'"
                      @keyup.enter="doSearch"
                    />
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="float-sm-end d-flex">
                  <div class="text-sm-right">
                    <button
                      type="button"
                      class="btn btn-success btn-rounded mb-2 mr-2"
                      @click="openCreateModal"
                    >
                      <i class="mdi mdi-plus mr-1"></i> Novo Cupom
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <table class="table table-centered table-nowrap table-hover">
                <thead>
                  <tr>
                    <th width="25%">Descrição</th>
                    <th width="15%">Responsável</th>
                    <th width="10%">Código</th>
                    <th width="10%">Tipo</th>
                    <th width="10%">Usos</th>
                    <th width="10%">Desconto</th>
                    <th width="10%">Status</th>
                    <th width="5%">#</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="cupon in cupons" :key="cupon.id">
                    <td class="link" @click="editCupon(cupon)">
                      {{ cupon.description }}
                    </td>
                    <td class="link" @click="editCupon(cupon)">
                      {{ cupon.manager }}
                    </td>
                    <td class="link" @click="editCupon(cupon)">
                      <code>{{ cupon.cupom }}</code>
                    </td>
                    <td class="link" @click="editCupon(cupon)">
                      <span v-if="cupon.type === 'single_multi_use'" class="badge bg-primary-subtle text-primary">
                        Múltiplo Uso
                      </span>
                      <span v-else class="badge bg-secondary-subtle text-secondary">
                        Uso Único
                      </span>
                    </td>
                    <td class="link" @click="editCupon(cupon)">
                      <div v-if="cupon.type === 'single_multi_use'">
                        {{ cupon.uses_count }} / {{ cupon.max_uses }}
                      </div>
                      <div v-else>
                        {{ cupon.used ? 'Usado' : 'Disponível' }}
                      </div>
                    </td>
                    <td class="link" @click="editCupon(cupon)">
                      {{ cupon.discount }}%
                    </td>
                    <td>
                      <b-dropdown
                        size="sm"
                        style="min-width:100px"
                        :variant="cupon.status === 1 ? 'success' : 'danger'"
                      >
                        <template v-slot:button-content>
                          {{ cupon.status === 1 ? 'Ativo' : 'Inativo' }}
                          <i class="mdi mdi-chevron-down"></i>
                        </template>
                        <span>
                          <b-dropdown-item-button @click="toggleStatus(cupon)">
                            {{ cupon.status === 1 ? 'Inativar' : 'Ativar' }}
                          </b-dropdown-item-button>
                        </span>
                      </b-dropdown>
                    </td>
                    <td>
                      <button
                        type="button"
                        @click="deleteCupon(cupon)"
                        class="link btn btn-outline-danger btn-sm"
                      >
                        <i class="bx bx-trash"></i>
                      </button>
                    </td>
                  </tr>
                  <tr v-if="cupons.length === 0">
                    <td colspan="8" class="text-center text-muted py-4">
                      Nenhum cupom cadastrado
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                      v-model="pagination.current_page"
                      :total-rows="pagination.total"
                      :per-page="pagination.per_page"
                      @input="loadCupons"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Create/Edit Modal -->
    <b-modal
      v-model="showModal"
      :title="isEditing ? 'Editar cupom' : 'Criar novo cupom'"
      size="lg"
      hide-footer
      @hidden="resetForm"
    >
      <p class="text-muted mb-4">Configure os cupons de desconto para o evento</p>

      <form @submit.prevent="saveCupon">
        <!-- Tipo de cupom -->
        <div class="mb-4">
          <label class="form-label d-block mb-3">Tipo de cupom <span class="text-danger">*</span></label>
          <div class="row">
            <div class="col-md-6">
              <div
                class="cupon-type-card"
                :class="{ active: form.type === 'single_multi_use' }"
                @click="form.type = 'single_multi_use'"
              >
                <div class="d-flex align-items-start">
                  <i class="bx bx-infinite text-primary" style="font-size: 32px; margin-right: 1rem;"></i>
                  <div>
                    <h6 class="mb-1">Um código para várias compras</h6>
                    <small class="text-muted">
                      Crie um único código que pode ser usado múltiplas vezes até atingir o limite
                    </small>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div
                class="cupon-type-card"
                :class="{ active: form.type === 'bulk_single_use' }"
                @click="form.type = 'bulk_single_use'"
              >
                <div class="d-flex align-items-start">
                  <i class="bx bx-purchase-tag text-success" style="font-size: 32px; margin-right: 1rem;"></i>
                  <div>
                    <h6 class="mb-1">Vários códigos únicos</h6>
                    <small class="text-muted">
                      Gere múltiplos códigos, cada um podendo ser usado apenas uma vez
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Informações básicas -->
        <div class="mb-3">
          <label class="form-label">Descrição <span class="text-danger">*</span></label>
          <input
            v-model="form.description"
            type="text"
            class="form-control"
            placeholder="Ex: Cupom para parceiros, Early Bird, etc."
            :class="{ 'is-invalid': submitted && $v.form.description.$error }"
          />
          <div v-if="submitted && !$v.form.description.required" class="invalid-feedback">
            O campo descrição é obrigatório.
          </div>
        </div>

        <div class="mb-3">
          <label class="form-label">Responsável <span class="text-danger">*</span></label>
          <input
            v-model="form.manager"
            type="text"
            class="form-control"
            placeholder="Nome do responsável pela criação"
            :class="{ 'is-invalid': submitted && $v.form.manager.$error }"
          />
          <div v-if="submitted && !$v.form.manager.required" class="invalid-feedback">
            O campo responsável é obrigatório.
          </div>
        </div>

        <div class="mb-3">
          <label class="form-label">Desconto (%) <span class="text-danger">*</span></label>
          <input
            v-model.number="form.discount"
            type="number"
            min="0"
            max="100"
            step="0.01"
            class="form-control"
            placeholder="Ex: 25"
            :class="{ 'is-invalid': submitted && $v.form.discount.$error }"
          />
          <small class="text-muted">Porcentagem de desconto que será aplicada no valor total</small>
          <div v-if="submitted && !$v.form.discount.required" class="invalid-feedback d-block">
            O campo desconto é obrigatório.
          </div>
          <div v-if="submitted && !$v.form.discount.between" class="invalid-feedback d-block">
            O desconto deve estar entre 0 e 100%.
          </div>
        </div>

        <!-- Campos condicionais baseados no tipo -->
        <div v-if="form.type === 'single_multi_use'">
          <div class="mb-3">
            <label class="form-label">Código do Cupom <span class="text-danger">*</span></label>
            <input
              v-model="form.cupom"
              type="text"
              class="form-control text-uppercase"
              placeholder="Ex: BLACKFRIDAY, PROMO2024"
              :class="{ 'is-invalid': submitted && $v.form.cupom.$error }"
              :disabled="isEditing"
            />
            <small class="text-muted">Este será o código que os clientes irão usar no checkout</small>
            <div v-if="submitted && !$v.form.cupom.required" class="invalid-feedback d-block">
              O campo código do cupom é obrigatório.
            </div>
            <div v-if="isEditing" class="text-info mt-1">
              <small><i class="bx bx-info-circle"></i> O código não pode ser alterado após criação</small>
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label">Máximo de usos <span class="text-danger">*</span></label>
            <input
              v-model.number="form.max_uses"
              type="number"
              min="1"
              class="form-control"
              placeholder="Quantas vezes este código pode ser usado"
              :class="{ 'is-invalid': submitted && $v.form.max_uses.$error }"
            />
            <small class="text-muted">Número total de vezes que este código pode ser aplicado</small>
            <div v-if="submitted && !$v.form.max_uses.required" class="invalid-feedback d-block">
              O campo máximo de usos é obrigatório.
            </div>
          </div>
        </div>

        <div v-if="form.type === 'bulk_single_use'">
          <div class="mb-3">
            <label class="form-label">Prefixo dos Códigos <span class="text-muted">(opcional)</span></label>
            <input
              v-model="form.prefix"
              type="text"
              class="form-control text-uppercase"
              placeholder="Ex: EVENTFY"
              maxlength="15"
            />
            <small class="text-muted">Se preenchido, os códigos serão gerados como: PREFIXO + código aleatório (Ex: EVENTFY9A4B2C)</small>
          </div>
          <div class="mb-3">
            <label class="form-label">Quantidade de códigos <span class="text-danger">*</span></label>
            <input
              v-model.number="form.qtd"
              type="number"
              min="1"
              class="form-control"
              placeholder="Quantos códigos únicos deseja gerar"
              :class="{ 'is-invalid': submitted && $v.form.qtd.$error }"
            />
            <small class="text-muted">Cada código gerado poderá ser usado apenas uma vez</small>
            <div v-if="submitted && !$v.form.qtd.required" class="invalid-feedback d-block">
              O campo quantidade é obrigatório.
            </div>
          </div>
        </div>

        <!-- Actions -->
        <div class="d-flex justify-content-end gap-2 pt-3 border-top">
          <b-button variant="light" @click="showModal = false">
            Cancelar
          </b-button>
          <b-button variant="primary" type="submit" :disabled="loading">
            <i class="bx bx-check me-1" v-if="!loading"></i>
            <b-spinner small v-if="loading"></b-spinner>
            {{ loading ? 'Salvando...' : (isEditing ? 'Salvar alterações' : 'Criar cupom') }}
          </b-button>
        </div>
      </form>
    </b-modal>
  </Layout>
</template>

<script>
import Swal from 'sweetalert2'
import Layout from '@/components/layout/vertical'
import PageHeader from '@/components/page-header'
import { required, requiredIf, minValue, between } from 'vuelidate/lib/validators'
import { getCupons, createCupon, updateCupon, deleteCupon as deleteCuponService, toggleCuponStatus } from './services'

export default {
  name: 'CuponsIndex',
  components: {
    Layout,
    PageHeader
  },
  validations: {
    form: {
      description: { required },
      manager: { required },
      discount: {
        required,
        between: between(0, 100)
      },
      cupom: {
        required: requiredIf(function () {
          return this.form.type === 'single_multi_use'
        })
      },
      max_uses: {
        required: requiredIf(function () {
          return this.form.type === 'single_multi_use'
        }),
        minValue: minValue(1)
      },
      qtd: {
        required: requiredIf(function () {
          return this.form.type === 'bulk_single_use'
        }),
        minValue: minValue(1)
      }
    }
  },
  data () {
    return {
      cupons: [],
      loading: false,
      showModal: false,
      isEditing: false,
      submitted: false,
      search: '',
      title: 'Cupons de Desconto',
      items: [
        {
          text: 'Bilheteria',
          to: '/payments/dashboard'
        },
        {
          text: 'Cupons',
          active: true
        }
      ],
      pagination: {
        current_page: 1,
        per_page: 20,
        total: 0
      },
      form: {
        description: '',
        manager: '',
        discount: 25,
        type: 'single_multi_use', // Padrão: Um código para várias compras
        cupom: '', // Para modalidade 1
        max_uses: 1,
        prefix: '', // Para modalidade 2
        qtd: 1
      }
    }
  },
  mounted () {
    this.loadCupons()
  },
  methods: {
    async loadCupons (page = 1) {
      try {
        const params = {
          page,
          limit: this.pagination.per_page,
          search: this.search || undefined
        }
        const response = await getCupons(params)
        this.cupons = response.data.data
        this.pagination = {
          current_page: response.data.current_page,
          per_page: response.data.per_page,
          total: response.data.total
        }
      } catch (error) {
        console.error('Erro ao carregar cupons:', error)
        this.$toast.error('Erro ao carregar cupons')
      }
    },
    doSearch () {
      this.pagination.current_page = 1
      this.loadCupons(1)
    },
    openCreateModal () {
      this.isEditing = false
      this.submitted = false
      this.resetForm()
      this.showModal = true
    },
    editCupon (cupon) {
      this.isEditing = true
      this.submitted = false
      this.form = {
        id: cupon.id,
        description: cupon.description,
        manager: cupon.manager,
        discount: cupon.discount || 25,
        type: cupon.type,
        cupom: cupon.cupom || '',
        max_uses: cupon.max_uses || 1,
        prefix: '',
        qtd: 1
      }
      this.showModal = true
    },
    async saveCupon () {
      this.submitted = true

      // Validate form
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$toast.error('Por favor, preencha todos os campos obrigatórios')
        return
      }

      try {
        this.loading = true

        const dataToSend = {
          description: this.form.description,
          manager: this.form.manager,
          discount: parseFloat(this.form.discount) || 0,
          type: this.form.type
        }

        if (this.form.type === 'single_multi_use') {
          dataToSend.cupom = this.form.cupom.trim().toUpperCase()
          dataToSend.max_uses = parseInt(this.form.max_uses) || 1
        } else {
          dataToSend.prefix = this.form.prefix.trim().toUpperCase()
          dataToSend.qtd = parseInt(this.form.qtd) || 1
        }

        if (this.isEditing) {
          await updateCupon(this.form.id, dataToSend)
          this.$toast.success('Cupom atualizado com sucesso')
        } else {
          await createCupon(dataToSend)
          const msg = this.form.type === 'bulk_single_use'
            ? `${this.form.qtd} cupom(ns) criado(s) com sucesso`
            : 'Cupom criado com sucesso'
          this.$toast.success(msg)
        }
        this.showModal = false
        this.submitted = false
        this.loadCupons(this.pagination.current_page)
      } catch (error) {
        console.error('Erro ao salvar cupom:', error)
        this.$toast.error('Erro ao salvar cupom')
      } finally {
        this.loading = false
      }
    },
    async toggleStatus (cupon) {
      try {
        await toggleCuponStatus(cupon.id)
        this.$toast.success('Status atualizado com sucesso')
        this.loadCupons(this.pagination.current_page)
      } catch (error) {
        console.error('Erro ao atualizar status:', error)
        this.$toast.error('Erro ao atualizar status')
      }
    },
    deleteCupon (cupon) {
      Swal.fire({
        title: 'Você tem certeza?',
        html: `Será excluído o cupom: <b>${cupon.cupom}</b>`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#f46a6a',
        cancelButtonColor: '#4a4848',
        cancelButtonText: 'CANCELAR',
        confirmButtonText: 'SIM, DESEJO EXCLUIR!'
      }).then(async (result) => {
        if (result.value) {
          try {
            await deleteCuponService(cupon.id)
            this.$toast.success('Cupom excluído com sucesso')
            this.loadCupons(this.pagination.current_page)
          } catch (error) {
            console.error('Erro ao excluir cupom:', error)
            this.$toast.error('Erro ao excluir cupom')
          }
        }
      })
    },
    resetForm () {
      this.submitted = false
      this.isEditing = false
      this.form = {
        description: '',
        manager: '',
        discount: 25,
        type: 'single_multi_use',
        cupom: '',
        max_uses: 1,
        prefix: '',
        qtd: 1
      }
      this.$nextTick(() => {
        if (this.$v) {
          this.$v.$reset()
        }
      })
    }
  }
}
</script>

<style scoped>
.link {
  cursor: pointer;
}

.swal2-popup {
  font-size: 11px !important;
}

.table-responsive {
  min-height: 300px;
}

.float-sm-end {
  float: right;
}

.bg-primary-subtle {
  background-color: rgba(85, 110, 230, 0.1) !important;
}

.text-primary {
  color: #556ee6 !important;
}

.bg-secondary-subtle {
  background-color: rgba(116, 120, 141, 0.1) !important;
}

.text-secondary {
  color: #74788d !important;
}

.gap-2 {
  gap: 0.5rem;
}

code {
  font-size: 0.875rem;
  color: #556ee6;
  background-color: rgba(85, 110, 230, 0.1);
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
}

/* Cupon Type Card */
.cupon-type-card {
  padding: 1.25rem;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  height: 100%;
  background: white;
}

.cupon-type-card:hover {
  border-color: #556ee6;
  box-shadow: 0 2px 8px rgba(85, 110, 230, 0.15);
}

.cupon-type-card.active {
  border-color: #556ee6;
  background-color: rgba(85, 110, 230, 0.05);
  box-shadow: 0 2px 12px rgba(85, 110, 230, 0.2);
}

.cupon-type-card h6 {
  font-weight: 600;
  color: #495057;
  margin-bottom: 0.25rem;
}

.cupon-type-card.active h6 {
  color: #556ee6;
}

/* Alert Info */
.alert-info {
  background-color: #e7f3ff;
  border-color: #b3d9ff;
  color: #004085;
  border-radius: 6px;
}

/* Uppercase inputs */
.text-uppercase {
  text-transform: uppercase;
}
</style>
